import { render, staticRenderFns } from "./orderNew.vue?vue&type=template&id=346ca2c4&scoped=true&"
import script from "./orderNew.vue?vue&type=script&lang=js&"
export * from "./orderNew.vue?vue&type=script&lang=js&"
import style0 from "./orderNew.vue?vue&type=style&index=0&lang=less&"
import style1 from "./orderNew.vue?vue&type=style&index=1&lang=css&"
import style2 from "./orderNew.vue?vue&type=style&index=2&id=346ca2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346ca2c4",
  null
  
)

export default component.exports